import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  /* Offset do rail fixo (64px) no padrao das telas responsivas; em
     <=720px o rail some (BottomNav assume) e a tela vai full-width. */
  width: calc(100vw - 64px);
  margin-left: 64px;
  padding: 15px var(--cco-pad) 0;
  box-sizing: border-box;

  @media (max-width: 720px) {
    width: 100vw;
    margin-left: 0;
  }
`;

export const ListWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const Line = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  gap: 12px;
  min-height: 60px;
  padding: 8px 0;
  border-bottom: 1px solid var(--cco-line);

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const EmailLabel = styled.label`
  font-size: var(--fs-subtitle);
  margin-right: 25px;
  text-align: center;
  word-break: break-word;
  color: ${(props) => props.theme.colors.darkblue};

  @media (max-width: 480px) {
    margin-right: 0;
    text-align: left;
  }
`;

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ButtonsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
`;
